<template>
  <div :class="['chat-bubble', { 'chat-bubble--mine': isMine }]">
    <div class="chat-bubble__content">
      <img
        v-if="message.imageUrl"
        :src="imageFullUrl"
        class="chat-bubble__image"
        @click="$emit('image-click', message.imageUrl)"
      />
      <p v-if="message.content" class="chat-bubble__text">{{ message.content }}</p>
      <div class="chat-bubble__meta">
        <span class="chat-bubble__time">{{ formattedTime }}</span>
        <span v-if="isMine && message.isRead" class="chat-bubble__read">
          <v-icon x-small color="blue lighten-1">mdi-check-all</v-icon>
        </span>
        <span v-else-if="isMine" class="chat-bubble__read">
          <v-icon x-small color="grey">mdi-check</v-icon>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChatBubble",
  props: {
    message: { type: Object, required: true },
    isMine: { type: Boolean, default: false },
  },
  computed: {
    formattedTime() {
      if (!this.message.createdAt) return "";
      const d = new Date(this.message.createdAt);
      const now = new Date();
      const isToday = d.toDateString() === now.toDateString();
      const time = d.toLocaleTimeString("th-TH", {
        hour: "2-digit",
        minute: "2-digit",
      });
      if (isToday) return time;
      return `${d.toLocaleDateString("th-TH", { day: "numeric", month: "short" })} ${time}`;
    },
    imageFullUrl() {
      if (!this.message.imageUrl) return "";
      if (this.message.imageUrl.startsWith("http")) return this.message.imageUrl;
      return `${this.$domain_api}${this.message.imageUrl}`;
    },
  },
};
</script>

<style scoped>
.chat-bubble {
  display: flex;
  margin-bottom: 8px;
  padding: 0 16px;
}

.chat-bubble--mine {
  justify-content: flex-end;
}

.chat-bubble__content {
  max-width: 70%;
  padding: 10px 14px;
  border-radius: 18px;
  background: #f0f0f5;
  color: #1a1a2e;
  position: relative;
  word-wrap: break-word;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
}

.chat-bubble--mine .chat-bubble__content {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
  border-bottom-right-radius: 4px;
}

.chat-bubble:not(.chat-bubble--mine) .chat-bubble__content {
  border-bottom-left-radius: 4px;
}

.chat-bubble__text {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  white-space: pre-wrap;
}

.chat-bubble__image {
  max-width: 100%;
  max-height: 250px;
  border-radius: 12px;
  margin-bottom: 4px;
  cursor: pointer;
  object-fit: cover;
}

.chat-bubble__meta {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  margin-top: 4px;
}

.chat-bubble__time {
  font-size: 11px;
  opacity: 0.6;
}

.chat-bubble--mine .chat-bubble__time {
  color: rgba(255, 255, 255, 0.8);
}

.chat-bubble__read {
  display: flex;
  align-items: center;
}
</style>
